import Alpine from 'alpinejs';
import { scrambleElementText } from '../../../../Helper/scramble-link-on-hover';

Alpine.data('hero', (options = {}) => ({
    init() {
        if (options.applyTextAnimationOnShow && !document.body.classList.contains('neos-backend')) {
            scrambleElementText(this.$root.querySelector('.hero__title'));
        }

        // Prevent fixed hero videos from being visible when overscrolling at the page bottom.
        const footer = document.querySelector('.footer');
        const hero = this.$root;

        if (footer && hero.classList.contains('hero--has-fixed-video')) {
            new IntersectionObserver(
                ([entry]) => {
                    hero.style.visibility = entry.isIntersecting ? 'hidden' : 'visible';
                },
                { threshold: 0 }
            ).observe(footer);
        }
    },
}));
